import { Card, Space, Typography } from '@sravni/react-design-system';
import cn from 'classnames';
import React from 'react';

import { useAppSelector } from 'shared/lib';

import { selectBankAccountOpened } from 'features/BankAccountOpened/model/bankAccountOpened.selector';
import { BankAccountOpenedButtons } from 'features/BankAccountOpened/ui/BankAccountOpenedButtons';

import catPng from '../assets/cat.png';

import styles from './BankAccountOpened.module.scss';

export const BankAccountOpened = () => {
  const { title, statusBlock } = useAppSelector(selectBankAccountOpened);

  return (
    <Card className={styles.rootCard}>
      <Space
        size={24}
        direction="vertical"
      >
        <Space
          align="center"
          className="h-text-center"
          direction="vertical"
          size={16}
        >
          <img
            className={styles.img}
            src={catPng as string}
            alt="Bank Account Opened"
          />

          <Typography.Heading level={3}>{title}</Typography.Heading>
        </Space>

        <Space
          size={8}
          direction="vertical"
        >
          {statusBlock?.stepProgress?.map((step) => (
            <Card
              className={styles.wrapperStep}
              size={16}
              variant="outlined"
              key={step.title}
            >
              <Space
                align="center"
                size={16}
                key={title}
              >
                <Space
                  className={cn(styles.stepContent, { [styles.blue]: step.isActive, [styles.gray]: !step.isActive })}
                  align="center"
                  justify="center"
                >
                  <Typography.Text
                    size={16}
                    strong
                  >
                    {step.ordering}
                  </Typography.Text>
                </Space>

                <Space
                  size={2}
                  direction="vertical"
                >
                  <Typography.Text
                    strong
                    size={14}
                  >
                    {step.title}
                  </Typography.Text>

                  <Typography.Text size={14}>{step.subtitle}</Typography.Text>
                </Space>
              </Space>
            </Card>
          ))}
        </Space>

        <BankAccountOpenedButtons />
      </Space>
    </Card>
  );
};
